import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { events } from "@/mocks/events";

export default function TimelineSection() {
  const sorted = [...events].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 6);

  return (
    <section className="w-full" aria-label="事件时间线">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="TIMELINE"
          title="沿着时间线，把这一年重新走一遍"
          description="下面按发生时间倒序排列近期整理的关键节点。每一条都可以直接进入对应档案，看到完整的前因后果。"
          actionLabel="按年份浏览"
          actionTo="/archive"
        />

        <ol className="relative mt-8 space-y-1 md:mt-10">
          {sorted.map((event, index) => (
            <li key={event.id}>
              <Link
                to={`/event/${event.id}`}
                className="group grid grid-cols-1 gap-3 rounded-lg px-3 py-4 transition-colors hover:bg-background-100 md:grid-cols-[110px_1fr_auto] md:items-center md:gap-6 md:px-4"
              >
                <span className="flex items-center gap-3">
                  <span
                    className={`flex h-2.5 w-2.5 shrink-0 rounded-full ${
                      index === 0 ? "bg-primary-500" : "bg-background-300"
                    }`}
                  />
                  <span className="font-heading text-sm font-bold text-foreground-700">
                    {event.date}
                  </span>
                </span>
                <span className="min-w-0">
                  <span className="block font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                    {event.title}
                  </span>
                  <span className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                    <span className="text-primary-600">{event.categoryName}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-pulse-line" />
                      热度 {event.heat}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-information-line" />
                      {event.status}
                    </span>
                  </span>
                </span>
                <span className="hidden items-center gap-1 text-xs font-medium text-foreground-500 transition-colors group-hover:text-primary-600 md:flex">
                  读档案
                  <i className="ri-arrow-right-line" />
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}